import React from 'react';
import CustomImageComponent from '@/components/CustomImageComponent';
import Link from 'next/link';
import { AnalysePostNode } from '@/types/analyses/page';

interface AnalysesCardProps {
    post?: AnalysePostNode;
    className?: string;
}

const AnalysesCard = ({ post, className }: AnalysesCardProps) => {
    return (
        <Link
            href={post?.uri || '#'}
            className={`flex flex-col items-center bg-gray-50 group hover:ring-2 dark:bg-white/5  gap-3 overflow-hidden dark:border-white/10 border border-primary/5 rounded-xl transition-all ${className}`}
            key={post?.databaseId || '#'}
        >
            {post?.featuredImage && (
                <div className={'w-full aspect-square  shrink-0 overflow-hidden'}>
                    <CustomImageComponent
                        sizes={post.featuredImage?.node?.mediaDetails?.sizes}
                        sourceUrl={post.featuredImage.node.sourceUrl}
                        title={post.featuredImage.node.title}
                        className={
                            'aspect-square shrink-0 opacity-90 transition-all group-hover:scale-105 group-hover:opacity-100 w-full !rounded-none'
                        }
                    />
                </div>
            )}
            <p className={'text-xs pt-1 p-2 max-lg:p-1 lg:text-base !leading-[2]'}>{post?.title}</p>
        </Link>
    );
};

export default AnalysesCard;
